export const formatRecurrenceQuantity = (recurrence) => {
  return recurrence == 0 ? '-' : recurrence
}
